import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { EMAIL_REPORT_QUERY } from '../../../graphql.js'
import { Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner'
import MessageCard from '../../MessageCard/MessageCard'
import '../Custom.css'
import { handleGraphQLErrors } from '../../../utils.js'

const EMAIL_REPORT = gql(EMAIL_REPORT_QUERY)

export default function EmailReport({ reportCode, location }) {
  console.log('EmailReport rendered: ', reportCode, location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function submitSearch() {
      try {
        const params = new URLSearchParams(location.search)
        const reportGroup = params.get('in_group') ? params.get('in_group') : 'NJ'
        const { data, errors } = await window.apolloClient.query({ query: EMAIL_REPORT, variables: { reportCode: 'CALENDAR', reportGroup: reportGroup } })
        if (data.emailReport) {
          setResults(data.emailReport)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    submitSearch()
  }, [location.search])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    return (
      <MessageCard title="Email Sent" message="The email containing the report has been sent." buttonText="Ok" clickUrl="/home" />
    )
  }
}
